<template>
    <RedesignBasePopover
        ref="popoverRef"
        :value="showMenu"
        :disabled="disabled"
        :visible-arrow="false"
        popper-class="redesign-new-group-popover"
        trigger="click"
        width="204"
        @show="showMenu = true"
        @hide="showMenu = false"
    >
        <template
            #reference
        >
            <slot :handle="onOpenPopover">
                <RedesignBaseButton
                    type="text"
                    icon="Plus"
                >
                    {{ $t('common.newGroup') }}
                </RedesignBaseButton>
            </slot>
        </template>
        <div class="w-full divide-y divide-ui-lines">
            <div
                class="flex items-center p-2 cursor-pointer rounded-sm hover:text-active-elements hover:bg-primary-actions-bg--focus transition-all"
                @click="onCreateFromTemplate"
            >
                <redesign-base-icon
                    name="LayoutTemplate"
                    :size="18"
                    class="text-primary-actions flex-shrink-0"
                />
                <div class="px-2 text-main-sm truncate">
                    {{ $t('dashboard.addGroupFromTemplate') }}
                </div>
            </div>
            <div
                class="flex items-center p-2 cursor-pointer rounded-sm hover:text-active-elements hover:bg-primary-actions-bg--focus transition-all"
                @click="onCreateEmptyGroup"
            >
                <redesign-base-icon
                    name="PlusSquare"
                    :size="18"
                    class="text-primary-actions flex-shrink-0"
                />
                <div class="px-2 text-main-sm truncate">
                    {{ $t('dashboard.addGroupEmpty') }}
                </div>
            </div>
        </div>
    </RedesignBasePopover>
</template>

<script setup lang="ts">
import RedesignBasePopover from '@/components/RedesignBaseComponents/RedesignBasePopover.vue'
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'
import { ref } from 'vue'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'

defineProps<{
    disabled?: boolean
}>()

const emit = defineEmits<{
    (e: 'create-empty-group'): void
    (e: 'create-from-template'): void
}>()

const showMenu = ref(false)

function onOpenPopover () {
    showMenu.value = true
}

function onCreateEmptyGroup () {
    emit('create-empty-group')
    showMenu.value = false
}

function onCreateFromTemplate () {
    emit('create-from-template')
    showMenu.value = false
}
</script>

